import Tag from "../tag/tag";
import LegacyLink from '../link/LegacyLink';
import LegacyThumbnail from "../legacyThumbnail/legacyThumbnail";
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";
import { CommentSVG, ShareSVG } from "../../svg";

import { formatArticleDate } from "../../helpers/dateHelper";
import { useSingleArticleTypeByDatasource } from "../../hooks/useStoryblokArticleTypes";
import { useSingleArticleCategoryByDatasource } from "../../hooks/useStoryblokCategories";

import styles from "./dynamicCard.module.scss";
import ArticleCardAuthorRow from "../articleCardComponents/articleCardAuthorRow";

//vertical
//sidebyside
function DynamicCard({thumbnail, type, category, summary, date, headline, authors, layout, oneline, uuid, use_legacy_thumbnail_background, enable_comments, comment_count, enable_social_sharing}){
  const articleType = useSingleArticleTypeByDatasource(type),
        articleCategory = useSingleArticleCategoryByDatasource(category)

  return (
    <article className={`${styles.card} ${styles[layout]} ${oneline ? styles.oneliner: null}`} key={uuid}>
      {typeof(thumbnail) === "string" || (thumbnail && thumbnail.filename !== null && thumbnail.filename !== "") ?
      <div className={styles.cardThumbnail}>
        {use_legacy_thumbnail_background ? (
          <LegacyThumbnail thumbnail_image={thumbnail} width={700} story_uuid={uuid} />
        ) : (
          <LegacyLink story_uuid={uuid}>
            <StoryblokImageBasic image={thumbnail} width={700} />
          </LegacyLink>
        )}
      </div>: null}
      <div className={styles.cardContent}>
        <div className={styles.tags}>
          {articleType ? (
            <LegacyLink story_uuid={articleType.uuid}>
              <Tag label={articleType.name} />
            </LegacyLink>
          ) : null}
          {articleCategory ? (
            <LegacyLink story_uuid={articleCategory.uuid}>
              <Tag label={articleCategory.name} />
            </LegacyLink>
          ) : null}
        </div>
        {date ? <div className={styles.date}>{formatArticleDate(date)}</div>:null}
        <LegacyLink story_uuid={uuid} withClass={styles.headline}><h3>{headline}</h3></LegacyLink>
        {summary ? <div className={styles.summary}>{summary}</div> : null}
        <div className={styles.authorRow}>
          <ArticleCardAuthorRow authors={authors} enableComments={enable_comments} enableSocialSharing={enable_social_sharing} commentCount={comment_count} />
        </div>
      </div>
    </article>
  )
}

export default DynamicCard;
